import { useEffect, useState } from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { routes, unAuthRoutes } from './';
import parseRoutes, { CommonRouteObject, ParsedType } from './routerGenerator';
// store
import { useStore } from '@/stores';
import { contains } from '@/utils';
import { observer } from 'mobx-react';
import { RouteContext } from './provider';
import NoPermission from '@/components/NoPermission';

const Router = () => {
  const [parsed, setParsed] = useState<ParsedType>({} as ParsedType);
  const userStore = useStore('user');
  // 处理路由权限，生成路由和菜单和面包屑
  useEffect(() => {
    // 此处permission为字符串数组
    const data = parseRoutes(
      routes as CommonRouteObject[],
      (permission?: string[]) => {
        if (!permission?.length) return true;
        return contains(userStore?.info?.permissions || [], permission);
      },
      <NoPermission />
    );
    setParsed(data);
  }, [routes, userStore.info]);

  return parsed.routerList?.length ? (
    <RouteContext.Provider value={parsed}>
      <RouterProvider router={createBrowserRouter([...parsed.routerList, ...unAuthRoutes])} />
    </RouteContext.Provider>
  ) : null;
};

export default observer(Router);
